<div fxLayout="column" fxLayoutGap="10px">
  <div>
    <mat-card appearance="outlined" fxFlexFill fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="20px"
              class="mat-elevation-z3" [ngClass]="{'mat-amber-A100': isOutstanding(), 'mat-red-A100': isDelinquent()}">
      <div fxFlex="grow" fxFlexAlign="center">
        {{ alertText }}
      </div>
    </mat-card>
  </div>
</div>
